export const SELECTION_CONDITION = [
  { value: 1, key: '選択無し' },
  { value: 2, key: '必須選択' },
  { value: 3, key: 'お1人様制御' },
  { value: 4, key: 'お1人様制御（必須選択）' },
];

export const DEFAULT_SELECTED_VALUE = 0;
export const DEFAULT_MENU = 0;
export const MAIN_MENU = 1;
export const SUB_MENU = 2;
export const SUB_TITLE_MENU = 3;
export const MENU_SELECTION_FLAG = { REGULAR: 0, SUB_TITLE: 1 };
